import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Crosshair, Clock, RefreshCcw } from 'lucide-react';
import { fadeUpWide, staggerContainer, staggerItem } from '../../utils/animations';

const viewportWide = { once: true, margin: '-50px' };

const cards = [
    {
        icon: Crosshair,
        title: 'Precision Hiring System',
        body: "Role design, skills testing, behavioral screening, and structured interviews. A repeatable framework, not resume roulette.",
    },
    {
        icon: Clock,
        title: 'Monthly Timeclock Audit',
        body: "Every month we review your VA's logs for drift, inefficiency, and accountability issues. Proactive oversight, not reactive damage control.",
    },
    {
        icon: RefreshCcw,
        title: 'Free Replacement Guarantee',
        body: "If a hire doesn't work out, we replace them. No restart fee. No additional recruiting charge. That's the standard.",
    },
];

export function ProgramSnapshot() {
    return (
        <section data-testid="program-snapshot" className="bg-[#F8F9FA] py-24 md:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUpWide} className="text-center mb-14">
                    <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-navy-900 mb-4 tracking-tight">
                        One Program. No Tiers. No Guesswork.
                    </h2>
                    <p className="text-[#6B7280] text-lg font-semibold">
                        $900/month plus your VA's salary in Year 1, decreasing to $699 in Year 2 and $299 in Year 3 and beyond. All-in cost for one full-time VA starts at approximately $2,500/month and drops from there.
                    </p>
                </motion.div>

                <motion.div
                    className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto"
                    variants={staggerContainer}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportWide}
                >
                    {cards.map((card) => (
                        <motion.div
                            key={card.title}
                            variants={staggerItem}
                            className="bg-white border border-gray-100 rounded-sm p-8 shadow-sm hover:shadow-md hover:border-gold-200 transition-all duration-300 group"
                        >
                            <div className="w-10 h-10 rounded-sm bg-navy-900 flex items-center justify-center mb-5 group-hover:bg-gold-400 transition-colors duration-300">
                                <card.icon size={18} className="text-white" strokeWidth={1.5} />
                            </div>
                            <h3 className="font-montserrat font-bold text-base text-navy-900 mb-3">{card.title}</h3>
                            <p className="text-[#6B7280] text-sm leading-relaxed">{card.body}</p>
                        </motion.div>
                    ))}
                </motion.div>

                <motion.div {...fadeUpWide} className="text-center mt-12">
                    <Link
                        to="/program"
                        className="inline-block border border-navy-900 text-navy-900 px-8 py-3.5 rounded-sm text-sm font-semibold tracking-wide hover:bg-navy-900 hover:text-white transition-colors duration-200"
                        data-testid="program-snapshot-cta"
                    >
                        See the Full Program
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
